import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type { StockMovementQueryInput } from "@/modules/inventory/domain/contracts";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useStockMovementsQuery } from "../api/queries";
import { StockMovementsFilter } from "../ui/StockMovementsFilter";
import { StockMovementsTable } from "../ui/StockMovementsTable";

export function StockMovementsPage() {
  const nav = useNavigate({ from: "/app/inventory/movements" });
  const search = useSearch({
    from: "/app/inventory/movements",
  }) as StockMovementQueryInput;
  const list = useStockMovementsQuery(search);

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ບັນທຶກການເຄື່ອນໄຫວ" },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-2">
          <h2 className="font-bold text-2xl tracking-tight">
            ບັນທຶກການເຄື່ອນໄຫວສະຕ໋ອກ
          </h2>
          <p className="text-muted-foreground">ປະຫວັດການປ່ຽນແປງສະຕ໋ອກທັງໝົດ</p>
        </div>
        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <StockMovementsFilter />
          <StockMovementsTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={search.offset ?? 0}
            limit={search.limit ?? 20}
            totalCount={list.data?.meta?.total ?? 0}
            sortBy={search.sort?.[0]?.field}
            sortOrder={search.sort?.[0]?.dir as "asc" | "desc" | undefined}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  ...search,
                  sort: [{ field: id, dir: desc ? "desc" : "asc" }],
                },
              })
            }
          />
        </div>
      </Main>
    </>
  );
}
